import GpxParser from 'gpxparser'

export default class Map {
    constructor(element, locations = null, gpx = null, start_location = null) {
        this.map = element

        this.initMap()
        this.initIcon()
        this.initIconStart()

        this.bounds = new google.maps.LatLngBounds();
        if (locations) {
            this.initLocations(locations);
        }

        if (gpx) {
            this.initGpxRoute(gpx);
        }

        if (start_location) {
            this.initStartLocation(start_location);
        }

        this.google_map.fitBounds(this.bounds);
    }

    initMap() {
        this.google_map = new google.maps.Map(this.map, {
            center: {lat: 51.4012265, lng: 4.7615381},
            zoom: 11,
            styles: [{
                "stylers": [{
                    "saturation": -100
                }]
            }],
        });

        // Make sure that we do not zoom in too much
        google.maps.event.addListenerOnce(this.google_map, 'bounds_changed', function () {
            this.setZoom(Math.min(15, this.getZoom()));
        });
    }

    initIcon() {
        this.icon = {
            url: TEMPLATE_PATH + "/assets/images/map_marker.png",
            scaledSize: new google.maps.Size(51, 51)
        };
    }

    initIconStart() {
        this.iconStart = {
            url: TEMPLATE_PATH + "/assets/images/map_marker_start.png",
            scaledSize: new google.maps.Size(51, 51)
        };
    }

    initLocations(locations) {
        this.createMarkers(locations)

        const bounds = this.retrieveBounds(locations);
    }

    initGpxRoute(gpx) {
        let oReq = new XMLHttpRequest();

        oReq.onload = (e) => { this.processRequest(oReq.response) };
        gpx = gpx + "?" + (new Date()).getTime();
        oReq.open("GET", gpx);
        oReq.send();
    }

    initStartLocation(start_location) {
        const latitude = parseFloat(start_location.lat);
        const longitude = parseFloat(start_location.lng);
        const position = {lat: latitude, lng: longitude};
        this.bounds.extend(position);

        const marker = new google.maps.Marker({
            position: position,
            map: this.google_map,
            icon: this.iconStart,
        })
    }

    processRequest(gpx_string) {
        let bounds = new google.maps.LatLngBounds();
        var gpx = new GpxParser();
        gpx.parse(gpx_string)
        let points = []
        for (const point of gpx.tracks[0].points) {
            points.push({lat: point.lat, lng: point.lon})
            this.bounds.extend({lat: point.lat, lng: point.lon})
        }

        const route = new google.maps.Polyline({
            path: points,
            geodesic: true,
            strokeColor: "#008000",
            strokeWeight: 4,
        });

        route.setMap(this.google_map);
    }

    createMarkers(locations) {
        for (const [key, location] of Object.entries(locations)) {
            // Create marker
            const latitude = parseFloat(location.lat);
            const longitude = parseFloat(location.lng);
            const position = {lat: latitude, lng: longitude};
            this.bounds.extend(position);

            const marker = new google.maps.Marker({
                position: position,
                map: this.google_map,
                icon: this.icon,
                title: key,
            })

            // Create Info Window
            const contentString =
                '<div class="maps-info-window" id="content">' +
                `<h3>${location.url ? `<a href="${location.url}" title="${key}">` : ''}${key}${location.url ? '</a>' : ''}</h3>` +
                `${location.street_name ?? ''} ${location.street_number ?? ''}<br>` +
                `${location.post_code ?? ''} ${location.city ?? ''}` +
                "</div>";
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });

            marker.addListener("click", () => {
                infowindow.open({
                    anchor: marker,
                    map: this.google_map,
                    shouldFocus: false,
                });
            });
        }
    }

    retrieveBounds(locations) {
        let bounds = new google.maps.LatLngBounds();

        for (const [key, location] of Object.entries(locations)) {

            bounds.extend(location)
        }

        return bounds
    }
}